import { RGBELoader } from 'three-stdlib';
import { useMount } from 'react-use';
import { BufferGeometryLoader, DataTexture } from 'three';
import { useTexture, useGLTF } from '@react-three/drei';
import { useLoader, Loader } from '@react-three/fiber';
import { URL as onlyBotsLogoURL } from '@/components/three/OnlyBotsLogo.js';
import {
    URL as sphereURL,
    sphere1Texture,
    sphere2Texture,
    sphere3Texture,
    sphere4Texture,
    sphere5Texture,
} from '@/components/three/Spheres.js';
import { bnwEnvironmentFile, colorEnvironmentFile } from '@/components/scenes/TitleScreen';
import editionCardAlphaImg from '@/img/edition-card-alpha.png';
import cardColorImg from '@/img/edition-card-color.png';
import colorSwatchImg from '@/img/color-swatch.png';
import scratchedMetalImg from '@/img/roughness-scratched-metal-1024.png';
import crtImage from '@/img/crt-aperture.png';
import * as fonts from '@/lib/fonts';
import { featuredBotsJSON } from '@/lib/globals';
import { humanURL } from '@/components/Human';
import { helixURL } from '@/components/Helix';
import {
    storyImage1,
    storyImage2,
    storyImage3,
    storyImage4,
    storyImage5,
    storyImage6,
    storyImage7,
    storyImage8,
} from '@/components/scenes/StorySequence';

const fontsToLoad = Object.values(fonts);
const assetsToPreload = [...fontsToLoad, featuredBotsJSON];

const preload = (): void => {
    assetsToPreload.forEach((url) => fetch(url));
};
export const useTitlePreloader = (): void => {
    useGLTF.preload(onlyBotsLogoURL);
    useGLTF.preload(sphereURL);
    useTexture.preload(crtImage);
    useTexture.preload(sphere1Texture);
    useTexture.preload(sphere2Texture);
    useTexture.preload(sphere3Texture);
    useTexture.preload(sphere4Texture);
    useTexture.preload(sphere5Texture);
    useLoader.preload(RGBELoader as new () => Loader<DataTexture>, bnwEnvironmentFile);
    useLoader.preload(RGBELoader as new () => Loader<DataTexture>, colorEnvironmentFile);
    useMount(preload);
};

export const useSecondaryPreloader = (): void => {
    useLoader.preload(BufferGeometryLoader, humanURL);
    useLoader.preload(BufferGeometryLoader, helixURL);
    useTexture.preload(storyImage1);
    useTexture.preload(storyImage2);
    useTexture.preload(storyImage3);
    useTexture.preload(storyImage4);
    useTexture.preload(storyImage5);
    useTexture.preload(storyImage6);
    useTexture.preload(storyImage7);
    useTexture.preload(storyImage8);
};

export const useEditionPreloader = (): void => {
    useTexture.preload(crtImage);
    useTexture.preload(editionCardAlphaImg);
    useTexture.preload(cardColorImg);
    useTexture.preload(colorSwatchImg);
    useTexture.preload(scratchedMetalImg);
    useLoader.preload(RGBELoader as new () => Loader<DataTexture>, bnwEnvironmentFile);
};
